// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__J7Bpy","amount":"Balance_amount__2zpAD","icon":"Balance_icon__247U3"};